import { render } from "./payslipsTemplatesNew.vue?vue&type=template&id=1105e499"
import script from "./payslipsTemplatesNew.vue?vue&type=script&lang=js"
export * from "./payslipsTemplatesNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__